import { IHisInfoGroupBehavior } from ".";
import { HisInformationItem } from "../..";
import { Department } from "../../../department";
import { IHisInformationApplicable } from "../../../document/items";

export class DefaultDepartmentBehavior implements IHisInfoGroupBehavior {
  constructor(private key: string, private departments: Department[]) {}

  createHisInfoItems(): HisInformationItem[] {
    if (this.departments === null) { return [ new HisInformationItem(this.key, "") ]; }

    const values = this.departments.map(x => x.name);
    const items = values.map(x => new HisInformationItem(this.key, x));
    return items;
  }

  areSameGroup(item: IHisInformationApplicable): boolean {
    return false;
  }
}
